import React from "react";
import {
  ServicesContainer,
  ServicesWrapper,
  Heading,
  Heading1,
  Heading2,
  HeadingDiv,
  Heading1Div,
  Footerimg,
  // ServicesWrapper,
  //Cardstyle,
  // ServicesCard,
  // ServicesIcon,
  // ServicesH2,
  // ServicesP,
} from "./ServicesElements";

import Faq1 from "../../images/Snowieslogo.png";
// import Faq2 from "../../images/faq2.png";
// import Discord from "../../images/Opensea.png";
// import Insta from "../../images/Instagram.png";
// import Twitter from "../../images/Twitter.png";
// import Opensea from "../../images/Discode.png";
// import CLC from "../../images/footerClC.png";
// import Card from   "./filp";
const Services = (props) => {
  return (
    <ServicesContainer id="faq">
      <ServicesWrapper>
        <Heading>Thanks for visting</Heading>
      </ServicesWrapper>
      <HeadingDiv>
        <Footerimg>
          <img src={Faq1}  alt="" />
        </Footerimg>
        <Heading1>Trippy chicks Club</Heading1>
        <Heading1Div>
          <Heading2 target="_blank" href="https://discord.gg/m82m99dUmt">
            Discord
          </Heading2>
          <Heading2
            target="_blank"
            href="https://www.instagram.com/trippychciks/"
          >
            Instagram
          </Heading2>
          <Heading2 target="_blank" href="https://twitter.com/chicks_trippy">
            Twitter
          </Heading2>
          <Heading2 target="_blank" href="https://opensea.io/TrippyChicks">
            Opensea
          </Heading2>
        </Heading1Div>
      </HeadingDiv>
    </ServicesContainer>
  );
};

export default Services;
